import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Form } from 'ui/components';

const initialState = {
  fractions: [
    {
      name: 'PCS',
      quantity: 1,
    },
  ],
};
export const FormFraction = ({ item, onInputChange }) => {
  const StateForm = useSelector((state) => state.Form);
  const [{ fractions }, setState] = React.useState(initialState);

  const $handleItemsChange = async (i, e) => {
    let newFractions = [...fractions];
    if (e?.target?.name === 'quantity') {
      newFractions[i]['quantity'] = e.target.valueNumber;
    } else {
      newFractions[i][e.target.name] = e.target.value;
    }

    setState((prevState) => ({
      ...prevState,
      fractions: newFractions,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      fractions: [
        ...fractions,
        {
          name: '',
          quantity: null,
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newFractions = [...fractions];
    newFractions.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      fractions: newFractions,
    }));
  };

  React.useEffect(() => {
    const input = {
      fractions,
    };

    onInputChange(input);
  }, [fractions]);

  React.useEffect(() => {
    if (!item) return;

    let f = [];
    if (item) {
      item?.forEach((i) => {
        f.push({
          id: i?.id,
          name: i?.name,
          quantity: i?.quantity,
        });
      });
    }
    setState((prevState) => ({ ...prevState, fractions: f }));
  }, [item]);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6 ">Fraction</div>
      {fractions?.map((e, i) => (
        <div
          className={cn('row align-items-end border-bottom py-3 m-0')}
          key={i}
        >
          <div className="col-10">
            <div className="row">
              <>
                {/* weight_point_based */}
                <div className="col-md-6 ps-0">
                  <Form.Input
                    required
                    autoComplete="off"
                    label="Nama"
                    name="name"
                    type="text"
                    value={e?.name}
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={
                      StateForm?.errors?.fractions ||
                      StateForm?.errors[`fractions.${i}.name`]
                    }
                  />
                </div>
                <div className="col-md-6 ps-0">
                  <Form.Input
                    required
                    disabled={i === 0}
                    autoComplete="off"
                    label="Quantity"
                    name="quantity"
                    type="number"
                    value={e?.quantity}
                    onChange={(e) => $handleItemsChange(i, e)}
                    error={
                      StateForm?.errors?.fractions ||
                      StateForm?.errors[`fractions.${i}.quantity`]
                    }
                  />
                </div>
              </>
            </div>
          </div>
          <div className="col-2 ">
            <button
              type="button"
              className="btn btn-danger rounded mb-3"
              style={{ minHeight: 36, minWidth: '100%' }}
              onClick={() => $removeField(i)}
              disabled={fractions?.length === 1 || i === 0}
            >
              <Fi.FiX />
            </button>
          </div>
        </div>
      ))}

      <div className="mt-3">
        <button
          type="button"
          className="btn btn-primary rounded mb-3"
          style={{ minHeight: 36, minWidth: '100%' }}
          onClick={() => $addMoreFields()}
        >
          <Fi.FiPlus className="me-2" /> Tambah Fraction
        </button>
      </div>
    </div>
  );
};
